import { c as _c } from "react/compiler-runtime";
import Download from "@/components/download/Download";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import { MemesArtResubmitAction } from "@/components/waves/memes/submission/MemesArtResubmitAction";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { SingleWaveDropTraits } from "./SingleWaveDropTraits";
import { WaveDropAdditionalInfo } from "./WaveDropAdditionalInfo";
import type { MemesDropDownloadData, MemesDropFileInfo, MemesDropMedia } from "./memesDropPanelTypes";
interface MemesDropDetailsSectionProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave | null;
  readonly artworkMedia?: MemesDropMedia | null | undefined;
  readonly fileInfo: MemesDropFileInfo | null;
  readonly previewImageData: MemesDropDownloadData | null;
  readonly promoVideoData: MemesDropDownloadData | null;
  readonly fileName: string;
  readonly canDelete: boolean;
  readonly onClose?: (() => void) | undefined;
}
export function MemesDropDetailsSection(t0) {
  const $ = _c(27);
  const {
    drop,
    wave,
    artworkMedia,
    fileInfo,
    previewImageData,
    promoVideoData,
    fileName,
    canDelete,
    onClose
  } = t0;
  const hasArtworkDownload = artworkMedia !== null && fileInfo !== null;
  const hasDownloads = hasArtworkDownload || previewImageData !== null || promoVideoData !== null;
  let t1;
  let t2;
  let t3;
  if ($[0] !== drop) {
    t1 = <SingleWaveDropTraits drop={drop} />;
    t2 = <SingleWaveDropInfoDetails drop={drop} />;
    t3 = <WaveDropAdditionalInfo drop={drop} />;
    $[0] = drop;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== artworkMedia || $[5] !== fileInfo || $[6] !== fileName || $[7] !== hasDownloads || $[8] !== previewImageData || $[9] !== promoVideoData) {
    t4 = hasDownloads ? <div className="tw-mt-8 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-8"><div className="tw-inline-grid tw-grid-cols-[auto_auto_auto] tw-items-center tw-gap-x-3 tw-gap-y-2">{artworkMedia && fileInfo && <><span className="tw-text-xs tw-font-medium tw-text-iron-600">Media Type:</span><span className="tw-text-xs tw-font-medium tw-text-iron-400">{fileInfo.extension.toUpperCase()}</span><Download href={artworkMedia.url} name={fileName} extension={fileInfo.extension} variant="text" alwaysShowText={true} /></>}{previewImageData && <><span className="tw-text-xs tw-font-medium tw-text-iron-600">Preview:</span><span className="tw-text-xs tw-font-medium tw-text-iron-400">{previewImageData.fileInfo.extension.toUpperCase()}</span><Download href={previewImageData.url} name={`${fileName}-preview`} extension={previewImageData.fileInfo.extension} variant="text" alwaysShowText={true} /></>}{promoVideoData && <><span className="tw-text-xs tw-font-medium tw-text-iron-600">Promo Video:</span><span className="tw-text-xs tw-font-medium tw-text-iron-400">{promoVideoData.fileInfo.extension.toUpperCase()}</span><Download href={promoVideoData.url} name={`${fileName}-promo-video`} extension={promoVideoData.fileInfo.extension} variant="text" alwaysShowText={true} /></>}</div></div> : null;
    $[4] = artworkMedia;
    $[5] = fileInfo;
    $[6] = fileName;
    $[7] = hasDownloads;
    $[8] = previewImageData;
    $[9] = promoVideoData;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== drop || $[12] !== onClose || $[13] !== wave) {
    t5 = wave && <MemesArtResubmitAction drop={drop} wave={wave} variant="button" onSourceDropDeleted={onClose} />;
    $[11] = drop;
    $[12] = onClose;
    $[13] = wave;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== canDelete || $[16] !== drop) {
    t6 = canDelete && drop.drop_type !== ApiDropType.Winner && <WaveDropDeleteButton drop={drop} />;
    $[15] = canDelete;
    $[16] = drop;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t7) {
    t8 = <div className="tw-px-4 tw-pb-8 sm:tw-px-6 md:tw-pb-10 xl:tw-px-20"><div className="tw-mx-auto tw-max-w-3xl tw-space-y-8">{t1}{t2}{t3}{t4}{t7}</div></div>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}